<template>
  <div
    class="form-content"
    :style="{
      flexDirection: isVerticalLayout ? 'column' : 'row',
      alignItems: isVerticalLayout ? 'flex-start' : 'center'
    }"
  >
    <div class="form-label-content" :style="{ marginBottom: isVerticalLayout ? '4px' : '0' }">
      <qfei-icon-more-two-outlined v-if="splitType !== 2" :class="{ 'mover-icon-disabled': splitType === 2 }" class="drag-mover" />
      <component class="filed-icon" :is="getFieldIcon(ele)" />
      <div class="drag-icon" :style="{ width: isVerticalLayout ? '100%' : '100px' }">
        <div class="drag-icon-label" :style="{ width: isVerticalLayout ? '100%' : '100px' }">
          <div class="form-label-text">
            <xl-label-text cursor="pointer" :value="ele?.label" :row="1" :key="ele.toast || isVerticalLayout" />
          </div>

          <template v-if="hasTooltip">
            <jw-tooltip>
              <qfei-icon-question-mark-outlined size="14" :style="{ color: 'var(--color-text-4)' }" />
              <template #content>
                <template v-if="ele.value === 'mobile'">
                  {{ $t('tips.defaultMobile') }}<br />
                  {{ $t('tips.defaultMobileFixed') }}
                </template>
                <template v-else>
                  {{ ele.toast }}
                </template>
              </template>
            </jw-tooltip>
          </template>
        </div>
      </div>
    </div>

    <div class="form-value-content" :style="{ width: isVerticalLayout ? '100%' : 'calc(100% - 100px)' }">
      <jw-space direction="vertical" :style="{ width: '100%' }" size="small">
        <jw-skeleton-line :rows="1" :line-height="16" />
      </jw-space>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import { QfeiIconMoreTwoOutlined, QfeiIconQuestionMarkOutlined, QfeiIconSingleLineTextOutlined } from '@qfei-design/icons-vue';
import useFields from '@/hooks/fields';

const { fieldIconMapping } = useFields();
// 注入共享配置并处理默认值
const sharedConfig = ref(inject('sharedConfigData', {}));
const splitType = sharedConfig.value.splitType ?? 0; // 提供默认值避免undefined
const formAttribute = sharedConfig.value.formAttribute ?? {};

// 定义props并完善默认值
const props = defineProps({
  ele: {
    type: Object,
    default: () => ({}) // 确保默认是对象
  },
  type: {
    type: String,
    default: ''
  }
});

// 合并垂直布局判断逻辑
const isVerticalLayout = computed(() => {
  return formAttribute?.formLayout || props.type === 'abstract';
});
console.log('isVerticalLayout', formAttribute, isVerticalLayout.value);
// 提取tooltip显示条件
const hasTooltip = computed(() => {
  return !!props.ele.toast || props.ele.value === 'mobile';
});

// 图标获取逻辑封装
const getFieldIcon = (ele) => {
  return fieldIconMapping.value[Number(ele?.fieldType)] || QfeiIconSingleLineTextOutlined;
};
</script>

<style scoped lang="less">
@import './tab-detail-label.less';
</style>
